import InputValidator from "Helpers/InputValidator";

require("es6-promise").polyfill();
require("isomorphic-fetch");

export default function Search(container) {
  const searchContainer = container;
  const btnOpenSearchList = document.querySelectorAll(".js-search-btn");
  const btnCloseSearch = container.querySelector(".js-search-close");
  const form = container.querySelector(".js-search-layout-form");
  const bodyElement = document.body;
  form.setAttribute("novalidate", true);
  const url = form.action;

  const inputElement = container.querySelector(".js-search-text-field-input");
  const inputInvalidClass = inputElement.getAttribute("data-invalid-class");
  const inputValidator = new InputValidator({
    domElement: inputElement,
    requiredFlag: true,
    errorClass: inputInvalidClass
  });

  for (let i = 0, len = btnOpenSearchList.length; i < len; i++) {
    const btnOpenSearch = btnOpenSearchList[i];

    btnOpenSearch.addEventListener("click", function openSearch() {
      if (!searchContainer.classList.contains("is-show")) {
        searchContainer.classList.add("is-show");
        bodyElement.style.overflowY = "hidden";
      }

      if (!this.classList.contains("is-active")) {
        this.classList.add("is-active");
      } else {
        this.classList.remove("is-active");
        closeSearch();
      }
    });
  }

  btnCloseSearch.addEventListener("click", closeSearch);

  function closeSearch() {
    searchContainer.classList.remove("is-show");
    bodyElement.style.overflowY = "auto";

    for (let i = 0, len = btnOpenSearchList.length; i < len; i++) {
      const btnOpenSearch = btnOpenSearchList[i];

      if (btnOpenSearch.classList.contains("is-active")) {
        btnOpenSearch.classList.remove("is-active");
      }
    }
  }

  form.addEventListener("submit", function submitForm(e) {
    e.preventDefault();
    const isValid = validateForm();
    if (isValid) {
      const data = new FormData(form);
      data.append("ajax", "Y");
      // console.log("запрос", isValid);
      makeRequest(url, data);
    }
    // console.log("запрос", isValid);
  });

  function makeRequest(urlForm, data) {
    fetch(urlForm, {
      method: "POST",
      body: data,
      credentials: "same-origin"
    })
      .then(function requestSuccess(response) {
        if (response.ok) {
          // console.log("ok", response);
          return response.blob();
        }

        throw new Error("Network response was not ok.");
      })
      .then(function requestResponse() {
        handleResponse();
      });
  }

  function handleResponse() {
    closeSearch();
    form.reset();
    document.location.replace(
      "http://develop.nologostudio.ru/html/ruvek-fe/build/search.html"
    );
  }

  function validateTextInputs(inputsValidators) {
    let isValid = true;

    if (Array.isArray(inputsValidators)) {
      for (let i = 0, len = inputsValidators.length; i < len; i++) {
        const isFormElementValid = inputsValidators[i].validate();
        if (!isFormElementValid) {
          isValid = false;
        }
      }
    } else {
      const isFormElementValid = inputsValidators.validate();
      if (!isFormElementValid) {
        isValid = false;
      }
    }

    return isValid;
  }

  function validateForm() {
    let isValid = true;

    if (form.classList.contains("is-invalid")) {
      form.classList.remove("is-invalid");
    }

    const isTextInputsValid = validateTextInputs(inputValidator);

    if (!isTextInputsValid) {
      isValid = false;

      if (!form.classList.contains("is-invalid")) {
        form.classList.add("is-invalid");
      }
    }

    return isValid;
  }
}
